import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { SafeHtml, SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import 'dotdotdot-js'

@Component({
  selector: 'app-benefit-detail',
  templateUrl: './benefit-detail.component.html',
  styleUrls: ['./benefit-detail.component.scss']
})
export class BenefitDetailComponent implements OnInit, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  constructor(private route: ActivatedRoute, private _mainService: MainService,
    private _sanitizer: DomSanitizer) { }
  language = JSON.parse(localStorage.getItem('language'))
  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';

  benefit: any;
  showbenefit: any;
  detail: any;
  file_pdf: string;
  benefitTitle: string;
  benefitType: string;
  benefitDate: string;
  pdfUrl_path: any;
  pdfUrl: any;
  id: any;

  filesize: any;

  flag: any

  private player;
  private ytEvent;

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.benefit = this.route.params.subscribe(params => {
      this._mainService.getbenefitByID(params['id']).subscribe(response => {
        //case news type is text
        if (this.flag == 'th') {
          if (response[0].benefit_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail = this.htmlTransforms(response[0].detail);
            this.detail = this.htmlTransforms(response[0].detail);

            this.showbenefit = response;
            this.benefitTitle = response[0].title;
            this.benefitType = response[0].benefit_type;
            this.benefitDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].benefit_type === 'image') {
            this.file_pdf = 'no';
            this.showbenefit = response;
            this.detail = response[0].detail;
            this.benefitTitle = response[0].title;
            this.benefitType = response[0].benefit_type;
            this.benefitDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].benefit_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail;
            this.showbenefit = response;
            this.pdfUrl = this.urlTransform(response[0].detail);
            this.benefitTitle = response[0].title;
            this.benefitType = response[0].benefit_type;

            this.filesize = response[0].filesize

            this.benefitDate = this._mainService.date_thai(response[0].publicDate);

          }
          else if (response[0].benefit_type === 'vdo') {
            this.file_pdf = 'no';
            this.showbenefit = response;
            this.detail = response[0].detail;
            this.id = response[0].detail;
            this.benefitTitle = response[0].title;
            this.benefitType = response[0].benefit_type;
            this.benefitDate = this._mainService.date_thai(response[0].publicDate);

          }
        } else {
          if (response[0].benefit_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail_en = this.htmlTransforms(response[0].detail_en);
            this.detail = this.htmlTransforms(response[0].detail_en);

            this.showbenefit = response;
            this.benefitTitle = response[0].title_en;
            this.benefitType = response[0].benefit_type;
            this.benefitDate = response[0].publicDate;

          } else if (response[0].benefit_type === 'image') {
            this.file_pdf = 'no';
            this.showbenefit = response;
            this.detail = response[0].detail_en;
            this.benefitTitle = response[0].title_en;
            this.benefitType = response[0].benefit_type;
            this.benefitDate = response[0].publicDate;

          } else if (response[0].benefit_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail_en;
            this.showbenefit = response;
            this.pdfUrl = this.urlTransform(response[0].detail_en);
            this.benefitTitle = response[0].title_en;
            this.benefitType = response[0].benefit_type;

            this.filesize = response[0].filesize

            this.benefitDate = response[0].publicDate;

          }
          else if (response[0].benefit_type === 'vdo') {
            this.file_pdf = 'no';
            this.showbenefit = response;
            this.detail = response[0].detail_en;
            this.id = response[0].detail_en;
            this.benefitTitle = response[0].title_en;
            this.benefitType = response[0].benefit_type;
            this.benefitDate = response[0].publicDate;

          }
        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,

        })
      })
    })
  }

  ngOnDestroy() {
    this.benefit.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }


  onStateChange(event) {
    this.ytEvent = event.data;
  }
  savePlayer(player) {
    this.player = player;
  }
}